// Minimal RFC-4180 CSV + browser download. No dependencies.

function escapeCell(value) {
  const s = value == null ? '' : String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// rows: Array<Array<string|number|null>>. Returns a CSV string with a UTF-8 BOM
// (so Excel reads Vietnamese/non-ASCII correctly).
export function toCsv(rows) {
  const body = rows.map((row) => row.map(escapeCell).join(',')).join('\r\n');
  return '﻿' + body;
}

export function downloadCsv(filename, csvString) {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
